import { CALL_API } from "redux-api-middleware";
import { ho } from "apis/homeowner/ho";
import {
    REQUEST_POLICY_INFO_RESULTS,
    RECEIVE_POLICY_INFO_RESULTS,
    ERROR_POLICY_INFO_RESULTS,

    REQUEST_CASE_INFO_RESULTS,
    RECEIVE_CASE_INFO_RESULTS,
    ERROR_CASE_INFO_RESULTS,

    REQUEST_CASE_NOTES_RESULTS,
    RECEIVE_CASE_NOTES_RESULTS,
    ERROR_CASE_NOTES_RESULTS,

    REQUEST_CHANGE_APPRAISER,
    RECEIVE_CHANGE_APPRAISER,
    ERROR_CHANGE_APPRAISER,

    REQUEST_CASE_CONVERSION_OPTIONS,
    RECEIVE_CASE_CONVERSION_OPTIONS,
    ERROR_CASE_CONVERSION_OPTIONS,

    REQUEST_CASE_CONVERSION,
    RECEIVE_CASE_CONVERSION,
    ERROR_CASE_CONVERSION,
} from "typeConstants";
import responseHandler from "responseHandler";

const getCaseInfo = (text) => {
    return dispatch => (
        dispatch({
            [CALL_API]: {
                endpoint: ho.caseInfo(text),
                method: "GET",
                types: [
                    REQUEST_CASE_INFO_RESULTS,
                    {
                        type: RECEIVE_CASE_INFO_RESULTS,
                        payload: (action, state, res) =>
                            res.json()
                                .then(data => {
                                    return data;
                                })
                    }, {
                        type: ERROR_CASE_INFO_RESULTS,
                        payload: (action, state, res) => {
                            responseHandler.error(res, dispatch);
                        }
                    }
                ]
            }
        })
    );
};

const getCaseNotes = (controlIdNumber) => {
    return dispatch => (
        dispatch({
            [CALL_API]: {
                endpoint: `/case-notes/${controlIdNumber}/general`,
                method: "GET",
                types: [
                    REQUEST_CASE_NOTES_RESULTS,
                    {
                        type: RECEIVE_CASE_NOTES_RESULTS,
                        payload: (action, state, res) =>
                            res.json()
                                .then(data => {
                                    return data;
                                })
                    }, {
                        type: ERROR_CASE_NOTES_RESULTS,
                        payload: (action, state, res) => {
                            responseHandler.error(res, dispatch);
                        }
                    }
                ]
            }
        })
    );
};

const getPolicyInfo = (text) => {
    return dispatch => (
        dispatch({
            [CALL_API]: {
                endpoint: ho.policyInfo(text),
                method: "GET",
                types: [
                    REQUEST_POLICY_INFO_RESULTS,
                    {
                        type: RECEIVE_POLICY_INFO_RESULTS,
                        payload: (action, state, res) =>
                            res.json()
                                .then(data => {
                                    return data;
                                })
                    }, {
                        type: ERROR_POLICY_INFO_RESULTS,
                        payload: (action, state, res) => {
                            responseHandler.error(res, dispatch);
                        }
                    }
                ]
            }
        })
    );
};

const changeAppraiserAssigned = (appraisalId, appraiserId, callback, caseAssignmentDetails = null) => {
    return dispatch => (
        dispatch({
            [CALL_API]: {
                endpoint: ho.changeAppraiserAssigned(appraisalId, appraiserId),
                method: "PUT",
                body: JSON.stringify(caseAssignmentDetails),
                types: [
                    REQUEST_CHANGE_APPRAISER,
                    {
                        type: RECEIVE_CHANGE_APPRAISER,
                        payload: (action, state, res) => {
                          return res.json()
                            .then(data => {
                              if (callback) {
                                callback(data);
                              }
                              return data;
                            });
                        }
                    }, {
                        type: ERROR_CHANGE_APPRAISER,
                        payload: (action, state, res) => {
                            responseHandler.error(res, dispatch);
                        }
                    }
                ]
            }
        })
    );
};

const getCaseConversionOptions = (controlNumber) => {
    return dispatch => (
        dispatch({
            [CALL_API]: {
                endpoint: ho.getCaseConversionOptions(controlNumber),
                method: "GET",
                types: [
                    REQUEST_CASE_CONVERSION_OPTIONS,
                    {
                        type: RECEIVE_CASE_CONVERSION_OPTIONS,
                        payload: (action, state, res) =>
                            res.json()
                                .then(data => {
                                    return data;
                                })
                    }, {
                        type: ERROR_CASE_CONVERSION_OPTIONS,
                        payload: (action, state, res) => {
                            responseHandler.error(res, dispatch);
                        }
                    }

                ]
            }
        })
    );
};

const convertCaseSurveyType = (controlNumber, surveyTypeCode, callback = null) => {
    return dispatch => (
        dispatch({
            [CALL_API]: {
                endpoint: ho.convertCaseSurveyType(controlNumber, surveyTypeCode),
                method: "POST",
                types: [
                    REQUEST_CASE_CONVERSION,
                    {
                        type: RECEIVE_CASE_CONVERSION,
                        payload: (action, state, res) => {
                            res.json()
                                .then(data => {
                                    setTimeout(() => {
                                        if (callback) callback(controlNumber);
                                        responseHandler.success("Case Converted", dispatch);
                                    }, 0);
                                    return data;
                                });
                        }
                    }, {
                        type: ERROR_CASE_CONVERSION,
                        payload: (action, state, res) => {
                            responseHandler.error(res, dispatch);
                        }
                    }
                ]
            }
        })
    );
};

export {
    getCaseInfo,
    getCaseNotes,
    getPolicyInfo,
    changeAppraiserAssigned,
    getCaseConversionOptions,
    convertCaseSurveyType,
};
